import { derived, writable } from 'svelte/store';
import * as contracts from './lib/contracts';
import { COMPS, getAllocation, getAllowance, getRate } from './lib/contracts';
import { countdown } from './lib/timeUtil';
export const competitionDataUpdown = writable(null);
export const challengeDataUpdown = writable(null);
export const competitionDataNeutral = writable(null);
export const challengeDataNeutral = writable(null);
export const scoresAndRewardsUpdown = writable(null);
export const leaderboardUpdown = writable(null);
export const scoresAndRewardsNeutral = writable(null);
export const leaderboardNeutral = writable(null);
export const selection = writable(COMPS.UPDOWN);
// Scores and rewards
export const nextDeadlineUpdown = writable(null);
export const deadlineCountdownUpdown = writable(null);
export const nextDeadlineNeutral = writable(null);
export const deadlineCountdownNeutral = writable(null);
const storedTransactions = localStorage.getItem("transactions") || "{}";
export const transactions = writable(JSON.parse(storedTransactions));
transactions.subscribe(value => {
    localStorage.setItem("transactions", JSON.stringify(value));
});
export const newNotifications = derived(transactions, $transactions => Object.values($transactions).some(t => t['new']));
export const allocation = writable("0");
export const conversionRate = writable(null);
export const allowance = writable(null);
challengeDataUpdown.subscribe(async (challengeData) => {
    // TODO only change deadline if phase has changed
    if (challengeData && challengeData.challenge && challengeData.phase) {
        let getDeadlineFn;
        if (challengeData.phase === 1) {
            getDeadlineFn = contracts.getSubmissionDeadline;
        }
        else if (challengeData.phase <= 3) {
            getDeadlineFn = contracts.getResultDeadline;
        }
        else {
            getDeadlineFn = contracts.getNextChallengeDeadline;
        }
        nextDeadlineUpdown.set(new Date(+((await getDeadlineFn(COMPS.UPDOWN, challengeData.challenge)) * 1000)));
    }
});
challengeDataNeutral.subscribe(async (challengeData) => {
    // TODO only change deadline if phase has changed
    if (challengeData && challengeData.challenge && challengeData.phase) {
        let getDeadlineFn;
        if (challengeData.phase === 1) {
            getDeadlineFn = contracts.getSubmissionDeadline;
        }
        else if (challengeData.phase <= 3) {
            getDeadlineFn = contracts.getResultDeadline;
        }
        else {
            getDeadlineFn = contracts.getNextChallengeDeadline;
        }
        nextDeadlineNeutral.set(new Date(+(await getDeadlineFn(COMPS.NEUTRAL, challengeData.challenge))));
    }
});
let countdownStopFn = () => { };
nextDeadlineUpdown.subscribe(deadline => {
    countdownStopFn();
    countdownStopFn = countdown(new Date(deadline), c => deadlineCountdownUpdown.set(c));
});
nextDeadlineNeutral.subscribe(deadline => {
    countdownStopFn();
    countdownStopFn = countdown(new Date(deadline), c => deadlineCountdownNeutral.set(c));
});
export async function loadContractValues() {
    const challengeNumbers = await Promise.all([
        contracts.getLatestChallengeNumber(COMPS.UPDOWN),
        contracts.getLatestChallengeNumber(COMPS.NEUTRAL)
    ]).then(results => { return results; });
    getAllocation().then(res => {
        allocation.set(res);
    });
    getRate().then(res => {
        conversionRate.set(res);
    });
    getAllowance().then(res => {
        allowance.set(res);
    });
    return contracts.batchCall(
    // specify contracts
    [
        contracts.getCompetitionAddress(COMPS.UPDOWN),
        contracts.getCompetitionAddress(COMPS.UPDOWN),
        contracts.getCompetitionAddress(COMPS.UPDOWN),
        contracts.getCompetitionAddress(COMPS.UPDOWN),
        contracts.getCompetitionAddress(COMPS.UPDOWN),
        contracts.getCompetitionAddress(COMPS.UPDOWN),
        contracts.getCompetitionAddress(COMPS.UPDOWN),
        contracts.getCompetitionAddress(COMPS.UPDOWN),
        contracts.getCompetitionAddress(COMPS.NEUTRAL),
        contracts.getCompetitionAddress(COMPS.NEUTRAL),
        contracts.getCompetitionAddress(COMPS.NEUTRAL),
        contracts.getCompetitionAddress(COMPS.NEUTRAL),
        contracts.getCompetitionAddress(COMPS.NEUTRAL),
        contracts.getCompetitionAddress(COMPS.NEUTRAL),
        contracts.getCompetitionAddress(COMPS.NEUTRAL),
        contracts.getCompetitionAddress(COMPS.NEUTRAL),
        contracts.getTokenAddress(),
        contracts.getTokenAddress(),
    ], 
    // specify function names
    [
        'getCompetitionPool',
        'getSubmissionCounter',
        'getPhase',
        'getCurrentTotalStaked',
        'getStake',
        'getSubmission',
        'getKeyHash',
        'getStakeThreshold',
        'getCompetitionPool',
        'getSubmissionCounter',
        'getPhase',
        'getCurrentTotalStaked',
        'getStake',
        'getSubmission',
        'getKeyHash',
        'getStakeThreshold',
        'allowance',
        'allowance'
    ], 
    // specify arguments
    [
        [],
        [challengeNumbers[COMPS.UPDOWN]],
        [challengeNumbers[COMPS.UPDOWN]],
        [],
        [contracts.activeUser],
        [challengeNumbers[COMPS.UPDOWN], contracts.activeUser],
        [challengeNumbers[COMPS.UPDOWN]],
        [],
        [],
        [challengeNumbers[COMPS.NEUTRAL]],
        [challengeNumbers[COMPS.NEUTRAL]],
        [],
        [contracts.activeUser],
        [challengeNumbers[COMPS.NEUTRAL], contracts.activeUser],
        [challengeNumbers[COMPS.NEUTRAL]],
        [],
        [contracts.activeUser, contracts.getCompetitionAddress(COMPS.UPDOWN)],
        [contracts.activeUser, contracts.getCompetitionAddress(COMPS.NEUTRAL)]
    ], 
    //specify return types
    [
        'float',
        'uint',
        'uint',
        'float',
        'float',
        'hash',
        'hash',
        'float',
        'float',
        'uint',
        'uint',
        'float',
        'float',
        'hash',
        'hash',
        'float',
        'float',
        'float' // 17
    ]).then(async (results) => {
        competitionDataUpdown.set({
            competitionPool: results[0] ? parseFloat(results[0]) : 0,
            submissionCounter: +results[1] || 0,
            totalStake: results[3] ? parseFloat(results[3]) : 0,
            competitionKeyHash: results[6],
            stakeThreshold: +results[7],
            allowance: results[16]
        });
        challengeDataUpdown.set({
            activeUser: contracts.activeUser,
            challenge: challengeNumbers[COMPS.UPDOWN],
            phase: results[2],
            stake: results[4],
            submissionHash: results[5]
        });
        const offset = 8;
        competitionDataNeutral.set({
            competitionPool: results[0 + offset] ? parseFloat(results[0 + offset]) : 0,
            submissionCounter: +results[1 + offset] || 0,
            totalStake: results[3 + offset] ? parseFloat(results[3 + offset]) : 0,
            competitionKeyHash: results[6 + offset],
            stakeThreshold: +results[7 + offset],
            allowance: results[17]
        });
        challengeDataNeutral.set({
            activeUser: contracts.activeUser,
            challenge: challengeNumbers[COMPS.NEUTRAL],
            phase: results[2 + offset],
            stake: results[4 + offset],
            submissionHash: results[5 + offset]
        });
    });
}
export async function getScoresAndRewards(comp, challengeNumber) {
    return contracts.getRewardsAndScoresData(comp, 1, challengeNumber).then(indicators => {
        console.log("indicators", indicators);
        if (comp == COMPS.UPDOWN) {
            scoresAndRewardsUpdown.set({
                challengeScores: indicators.slice(0, challengeNumber),
                competitionScores: indicators.slice(challengeNumber, challengeNumber * 2),
                stakingRewards: indicators.slice(challengeNumber * 2, challengeNumber * 3),
                challengeRewards: indicators.slice(challengeNumber * 3, challengeNumber * 4),
                competitionRewards: indicators.slice(challengeNumber * 4, challengeNumber * 5),
                burnedAmount: indicators.slice(challengeNumber * 5, challengeNumber * 6),
            });
        }
        else {
            scoresAndRewardsNeutral.set({
                challengeScores: indicators.slice(0, challengeNumber),
                competitionScores: indicators.slice(challengeNumber, challengeNumber * 2),
                stakingRewards: indicators.slice(challengeNumber * 2, challengeNumber * 3),
                challengeRewards: indicators.slice(challengeNumber * 3, challengeNumber * 4),
                competitionRewards: indicators.slice(challengeNumber * 4, challengeNumber * 5),
                burnedAmount: indicators.slice(challengeNumber * 5, challengeNumber * 6),
            });
        }
    });
}
export async function getLeaderboard(comp) {
    const leaderboardCount = await contracts.getLeaderboardCount(comp);
    if (comp == COMPS.UPDOWN) {
        leaderboardUpdown.set(await contracts.getLeaderboardEntries(comp, leaderboardCount));
    }
    else {
        leaderboardNeutral.set(await contracts.getLeaderboardEntries(comp, leaderboardCount));
    }
}
